import React, {
  HTMLAttributes,
  useEffect,
  useRef,
  useState,
} from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, TitleWithText } from '@uncinc/uncinc-react-kitchen-sink';

import { ParagraphMap as Type } from '../../../types/uncinc_profile/paragraphs';
import { Button, ProjectMap, Switch } from '../../../components';
import SearchView from './SearchView';

import './style.scss';

interface ParagraphDowloadsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
  fluid?: boolean;
}

const ParagraphMap: React.FC<ParagraphDowloadsProps> = ({ entity, fluid = false }) => {
  const { t } = useTranslation();

  const paragraph = entity.toJS();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);
  const [currentTab, setCurrentTab] = useState('map');

  const uuid = paragraph.uuid[0].value;
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const link = paragraph.field_link[0];

  const classes = c('ParagraphMap');

  useEffect(() => {
    setWidth(wrapperRef.current?.clientWidth || 0);

    function handleWindowResize() {
      setWidth(wrapperRef.current?.clientWidth || 0);
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return (
    <div id={uuid} className={classes} ref={wrapperRef}>
      <Container>
        <div className="row">
          {(title || body) && (
            <div className="col-md-9 col-lg-6 mb-6 mb-lg-0">
              <TitleWithText title={title} text={body} />
            </div>
          )}

          <div className={`col-12${!title && !body ? ' mt-n6 mt-lg-n12' : ''}`}>
            <div className="ParagraphMap__actions">
              {link && (
                <Button
                  className="mb-6 mb-md-0"
                  type="text"
                  icon="chevron_right"
                  href={link.alias || link.uri}
                >
                  {link.title}
                </Button>
              )}

              <Switch
                currentTab={currentTab}
                onChange={(key) => setCurrentTab(key)}
                tabs={[
                  {
                    key: 'list',
                    label: t('buttons.list'),
                    icon: 'list',
                  },
                  {
                    key: 'map',
                    label: t('buttons.map'),
                    icon: 'map',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </Container>

      <Container fluid={fluid} className={fluid ? 'p-0' : ''}>
        <div className={`row${fluid ? ' no-gutters' : ''}`}>
          <div className="col-12 mt-4">
            {currentTab === 'map' ? (
              <ProjectMap />
            ) : (
              <SearchView wrapperWidth={width} />
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphMap;
